import { render, staticRenderFns } from "./FattorinoRettifica.vue?vue&type=template&id=17c8a652&"
import script from "./FattorinoRettifica.vue?vue&type=script&lang=ts&"
export * from "./FattorinoRettifica.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports